import { GridRowModel } from '@mui/x-data-grid';

export const CommonStatusTooltip = (row?: GridRowModel) => {
    if(!row?.['tooltipMessage']) {
        return <></>;
    }
    const tooltipMsgToRender = row['tooltipMessage'] as string;
    const rowId = row['id'] as string;

    return (
        <span>
            <p data-testid={`common-status-tooltip-${rowId}`}>
                {tooltipMsgToRender}
            </p>
        </span>
    );
};
